module.exports = __webpack_public_path__ + "static/media/9DESA28.968e4581.jpg";